import React from 'react';

import { InfoField } from '@occc-app/design-system';
import { EarningMechanismLoyaltyEventFragment } from '@occc/graphql';

interface ILoyaltyEventProps {
  earningMechanism: EarningMechanismLoyaltyEventFragment;
}

export const LoyaltyEvent: React.FC<ILoyaltyEventProps> = ({ earningMechanism }) => {
  return <InfoField label='Event Type' value={earningMechanism?.loyaltyEventEventType} />;
};
